export default __webpack_public_path__ + "static/eth-diamond-c2d49d0a427a31d3a650bf37bdab9075.gif";